module.exports = __webpack_public_path__ + "img/spin_btn.81cc5db8.png";